import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { ModalButtonsComponent } from '@app/components/modal/modalButtons.component';
import { SvgComponent } from '@app/components/svg/svg.component';

@Component({
  selector: 'app-image-modal',
  templateUrl: './image-modal.component.html',
  imports: [SvgComponent, ModalButtonsComponent],
  standalone: true,
})
export class ImageModalComponent implements OnInit, OnDestroy {
  @Input() imageSrc: string | undefined = undefined;
  @Input() imageAlt = '';
  @Output() closeModal = new EventEmitter<void>();

  private escapeListener?: (event: KeyboardEvent) => void;

  ngOnInit() {
    document.body.style.overflow = 'hidden';

    this.escapeListener = (event: KeyboardEvent) => {
      if (event.key === 'Escape') {
        this.close();
      }
    };
    document.addEventListener('keydown', this.escapeListener);
  }

  ngOnDestroy() {
    document.body.style.overflow = '';
    if (this.escapeListener) {
      document.removeEventListener('keydown', this.escapeListener);
    }
  }

  close() {
    this.closeModal.emit();
  }
}
